<template>
  <div
    class="map-action-btns-wrapper"
    :class="{ 'is-livetrack': isLiveTrack, 'is-started': isStarted }"
  >
    <b-button v-if="isLiveTrack" variant="outline" class="btn" @click="openLegend">
      <i class="icon-outline_info" />
    </b-button>
    <div v-show="isShowLegend" class="modal-legend">
      <div class="__header">
        <h6 class="__title">Keterangan</h6>
        <i class="__btn icon-outline_close" @click="closeLegend" />
      </div>
      <div class="__body">
        <div class="__wrapper">
          <div class="__title">Status Kendaraan</div>
          <div class="__content vehicle-status">
            <div
              v-for="vehicleStatus in vehicleStatuses"
              :key="vehicleStatus.color"
              class="vehicle-status-wrapper"
            >
              <div class="vehicle-icon">
                <img
                  :src="require(`@/assets/images/vehicles/van/van-${vehicleStatus.color}.png`)"
                />
              </div>
              <div>{{ vehicleStatus.text }}</div>
            </div>
          </div>
        </div>
        <div class="__wrapper">
          <div class="__title">Warna Laju Kendaraan</div>
          <div class="__content vehicle-speed">
            <div
              v-for="vehicleSpeed in vehicleSpeeds"
              :key="vehicleSpeed.key"
              class="vehicle-speed-wrapper"
            >
              <img :src="require(`@/assets/images/speedicon/${vehicleSpeed.key}.svg`)" />
              <div>{{ vehicleSpeed.text }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-button variant="outline" class="btn" @click="$emit('center')">
      <i class="icon-fill_target" />
    </b-button>
  </div>
</template>
<script>
export default {
  props: {
    isLiveTrack: {
      type: Boolean,
      default: false,
    },
    isStarted: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isShowLegend: false,
      vehicleStatuses: [
        {
          color: 'green',
          text: 'Berjalan', // moving
        },
        {
          color: 'orange',
          text: 'Diam', // idle
        },
        {
          color: 'red',
          text: 'Parkir', // parking
        },
        {
          color: 'blue',
          text: 'Assisted', // assisted
        },
        {
          color: 'grey',
          text: 'Offline', // offline
        },
      ],
      vehicleSpeeds: [
        {
          key: '80',
          text: `> 80 Km/Jam`,
        },
        {
          key: '61-80',
          text: `61 - 80 Km/Jam`,
        },
        {
          key: '41-60',
          text: `41 - 60 Km/Jam`,
        },
        {
          key: '21-40',
          text: `21 - 40 Km/Jam`,
        },
        {
          key: '20',
          text: `< 21 Km/Jam`,
        },
        {
          key: 'help',
          text: `Assisted`,
        },
      ],
    }
  },
  methods: {
    openLegend() {
      this.isShowLegend = true

      if (window.innerWidth <= 890) {
        document.querySelector('.mc-livetrack--qa-sidebar')?.classList.add('d-none')
      }
    },

    closeLegend() {
      this.isShowLegend = false

      if (window.innerWidth <= 890) {
        document.querySelector('.mc-livetrack--qa-sidebar')?.classList.remove('d-none')
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.map-action-btns-wrapper {
  position: absolute;
  left: 10px;
  right: 10px;
  bottom: 50px;

  display: flex;
  justify-content: flex-end;

  &.is-livetrack {
    justify-content: space-between;
  }

  &.is-started {
    bottom: 80px;
  }

  .btn {
    padding: 0;
    border: none;
    width: 40px;
    height: 40px;
    background-color: $white;
    border-radius: 4px;
    display: flex;
    justify-content: center;
    align-items: center;

    i {
      font-size: 20px;

      &:before {
        color: $mep-color-text-300;
      }
    }
  }
}

.modal-legend {
  position: absolute;
  bottom: 0;
  left: 50px;
  background-color: $white;
  border-radius: 4px;

  .__header {
    display: flex;
    gap: 10px;
    padding: 12px;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid $mep-color-text-100;

    .__title {
      margin-bottom: 0;
      font-size: 16px;
      font-weight: 600;
      color: $mep-primary;
    }

    .__btn {
      cursor: pointer;
      font-size: 24px;

      &:before {
        color: $mep-color-text-200;
      }
    }
  }

  .__body {
    padding: 12px;
    display: flex;
    flex-direction: column;
    gap: 16px;

    .__wrapper {
      display: flex;
      flex-direction: column;
      gap: 8px;
      font-size: 12px;

      .__title {
        color: $mep-color-text-300;
      }

      .__content {
        padding: 12px;
        border: 1px solid $teal-100;
        border-radius: 4px;

        &.vehicle-status {
          display: grid;
          grid-template-columns: 58px 58px 58px 58px;
          gap: 8px;

          .vehicle-status-wrapper {
            .vehicle-icon {
              width: 40px;
              height: 20px;
              display: flex;
              align-items: center;
              justify-content: center;

              img {
                transform: rotate(90deg);
                width: 17.84px;
                height: 37.3px;
              }
            }
          }
        }

        &.vehicle-speed {
          display: grid;
          grid-template-columns: 126px 126px;
          gap: 4px;

          .vehicle-speed-wrapper {
            text-align: center;
          }
        }
      }
    }
  }
}

@media screen and (max-width: 890px) {
  .modal-legend {
    position: fixed;
    z-index: 10;
    left: 0px;
    bottom: 0px;
    right: 0px;
    border-top-left-radius: 20px;
    border-top-right-radius: 20px;

    .__header {
      padding: 16px;
    }
  }
}

@media only screen and (max-width: 890px) {
  .map-action-btns-wrapper {
    left: 10px;
    right: 10px;
    bottom: 10px !important;
  }
}
</style>
